module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_18_1.83c797a0.jpeg";